import React, { Component } from 'react';
import ReactHTMLParser from 'react-html-parser';
import styled from 'styled-components';
import ComponentStyles from '../brand-styles/components/FilterWidget.styles';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import classNames from 'classnames';
import closeIcon from '../images/close.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import { breakpoints, colors } from '../style-utilities/variables';

//CTA shows View Recipes unless ctaText prop passed in says otherwise

const Widget = styled.div`
  /* position: sticky;
  position: -webkit-sticky; */
  top: 11%;
  padding: 10px 20px;
  .filter-title {
    margin: 0;
    display: inline;
  }
  h4 {
    margin-bottom: 10px;
  }
  .accordion {
    border: none;
  }
  .accordion__item {
    margin: 12px 0;
    #icon {
      float: right;
    }
  }
  .accordion__title,
  /* label {
    text-transform: capitalize;
  } */
  input {
    margin-right: 10px;
  }
  .accordion__title {
    background: transparent;
    border: 1px solid lightgrey;
    font-weight: 700;
    padding: 14px;
    outline: none;
  }
  .accordion__arrow {
    top: 0;
    float: right;
    margin-top: 0;
    position: relative;
  }
  .Tags {
    margin: 20px 0;
    border-bottom: 1px solid black;
    .tagHead {
      display: none;
      justify-content: space-between;
    }
    #tagTitle,
    #clearAll {
      display: inline;
    }
    #clearAll {
      font-size: 17px;
      margin: 14px 0 8px;
      /* border: 1px solid #333333; */
    }
    #tags {
      display: inline-block;
      padding: 10px;
      min-width: 100px;
      text-align: center;
      color: white;
      background-color: ${colors.primary};
      margin: 5px 3px;

      #deleteTagButton {
        cursor: pointer;
        float: right;
        margin-left: 6px;
      }
    }
    #excludedTags {
      display: inline-block;
      padding: 10px;
      min-width: 100px;
      text-align: center;
      color: white;
      background-color: ${colors.secondary};
      margin: 5px 3px 5px 0;
      font-weight: bold;

      #deleteTagButton,
      #deleteExcTag {
        cursor: pointer;
        float: right;
        margin-left: 4px;
        color: #ffffff;
      }
    }
    #excludedTags {
      text-decoration: line-through;
    }
  }
  #filterCloseIcon {
    visibility: hidden;
  }
  .ingredient-input {
    margin-bottom: 22px;
  }
  #viewRecipesButton {
    padding: 10px 40px;
    font-size: 16px;
    text-align: center;
    border: 1px solid #333333;
    background: ${colors.primary};
    font-weight: 600;
    color: #ffffff;
    width: 13em;
    @media (max-width: 320px) {
      width: 100%;
    }

    @media (min-width: 768px) {
      display: none;
    }
  }
  @media (max-width: ${breakpoints.tablet}) {
    margin-top: 20px;
    z-index: 200;
    padding: 40px 10px;
    width: 100vw;
    left: -100%;
    visibility: hidden;
    height: auto;
    bottom: 0;
    position: fixed;
    background: rgba(204, 204, 204, 0.8);
    transition: 0.3s left ease-out, 0.3s visibility ease-out;
    overflow: scroll;
    -webkit-overflow-scrolling: touch;
    &.filter-open {
      display: block;
      left: 0;
      visibility: visible;
      overflow: scroll;
      -webkit-overflow-scrolling: touch;
      z-index: 200;
      /* margin-bottom: 80px; */
      height: auto;
      .filter-container {
        background: #efeff0;
        padding: 20px;
      }
    }
    .filterButton {
      z-index: 201;
    }
    #filterCloseIcon {
      font-size: 20px;
      float: right;
      visibility: visible;
    }
  }
  .include-field {
    position: relative;
    border: 1px solid lightgray;
    margin-bottom: 12px;
    button {
      width: 20px;
      border: none;
      background: transparent;
      position: absolute;
      right: 22px;
      bottom: 12px;
      outline: none;
    }
  }
  .include-field input {
    width: 100%;
    border: none;
    padding: 14px;
    font-style: italic;
  }

  /* Dynamic brand styles */
  ${ComponentStyles}
`;

class FilterWidget extends Component {
  state = {
    isChecked: null,
    indexChecked: null
  };

  /**
   * METHOD: Onchange Handler for Input form
   */
  selectHandler = e => {
    let filterEle = [...this.props.state];
    const value = e.target.value;
    const index = filterEle.findIndex(type => type === value);
    if (index > -1) {
      filterEle = [...filterEle.slice(0, index), ...filterEle.slice(index + 1)];
    } else {
      filterEle.push(value);
    }
    this.props.setFilters(filterEle);
  };

  /**
   * METHOD: Render tags generated by filtering options
   */
  renderTags = () => {
    return this.props.state.map((tag, index) => {
      if (tag !== null && tag !== '') {
        return (
          <span id="tags" key={index}>
            {tag === 'veggie'
              ? tag.replace('veggie', 'vegetarian')
              : tag === 'chicken-turkey'
              ? tag.replace('chicken-turkey', 'chicken/turkey')
              : tag}
            <span id="deleteTagButton" onClick={() => this.deleteTag(tag)}>
              x
            </span>
          </span>
        );
      }
    });
  };
  /**
   * METHOD: Render tags generated by filtering options
   */
  renderIncludedIngTags = () => {
    if (this.props.includedIngredients) {
      return this.props.includedIngredients
        .filter(element => typeof element !== 'undefined')
        .map((tag, index) => {
          return (
            <span id="tags" key={index}>
              {tag}
              <span id="deleteTagButton" onClick={() => this.deleteTag(tag)}>
                x
              </span>
            </span>
          );
        });
    }
  };

  /**
   * METHOD: Render tags generated by filtering options
   */
  renderExcludedIngTags = () => {
    if (this.props.excludedIngredients) {
      return this.props.excludedIngredients.map((tag, index) => {
        return (
          <span id="excludedTags" key={index}>
            {tag}
            <span id="deleteExcTag" onClick={() => this.deleteExcTag(tag)}>
              x
            </span>
          </span>
        );
      });
    }
  };

  /**
   * METHOD: Delete a single tag
   */
  deleteTag = deletedEle => {
    //Deleting tag for Filter Elements array
    const newFilterElements = this.props.state.filter(
      element => element !== deletedEle && element !== null && element !== ''
    );
    this.props.setFilters(newFilterElements);
    // Deleting tag for Included Elements array
    let newIncFilterElements;
    if (this.props.includedIngredients) {
      newIncFilterElements = [...this.props.includedIngredients];
      let index = newIncFilterElements.indexOf(deletedEle);
      if (index !== -1) {
        newIncFilterElements.splice(index, 1);
        this.props.setIncludedIngFilters(newIncFilterElements);
      }
    }
  };

  /**
   * METHOD: Delete a single excluded tag
   */
  deleteExcTag = excTag => {
    const excElements = this.props.excludedIngredients.filter(
      element => element !== excTag
    );
    this.props.setExcludedIngFilters(excElements);
  };

  /**
   * METHOD: Delete all tags without included/excluded ingredient input fields
   */
  deleteAll = () => {
    const emptyArr = [];
    this.props.setFilters(emptyArr);
  };

  /**
   * METHOD: Delete all tags including included/excluded ingredient input fields
   */
  deleteAllFilteredEle = () => {
    const emptyArr = [];
    this.props.setFilters(emptyArr);
    if (this.props.includedIngredients || this.props.excludedIngredients) {
      this.props.setIncludedIngFilters(emptyArr);
      this.props.setExcludedIngFilters(emptyArr);
    }
  };

  render() {
    const {
      title,
      filterList,
      tagTitle,
      filterOpen,
      filterToggle,
      ingredientInput,
      includeExcludeTitle,
      ctaText
    } = this.props;
    const toggleClass = classNames({
      'filter-open': filterOpen
    });
    return (
      <Widget className={toggleClass}>
        <div className="filter-container">
          <span className="filter-title">{title}</span>
          <span id="filterCloseIcon" onClick={filterToggle}>
            <FontAwesomeIcon
              className="close"
              icon={faTimes}
              style={{ width: '20px', height: '20px' }}
            />
          </span>

          {// this.props.excludedIngredients && this.props.includedIngredients ? (
          (this.props.state && this.props.state.length > 0) ||
          (this.props.excludedIngredients &&
            this.props.excludedIngredients.length > 0) ||
          (this.props.includedIngredients &&
            this.props.includedIngredients.length > 0) ? (
            <div className="Tags">
              <div className="tagHead">
                <h4 id="tagTitle">{tagTitle}</h4>
              </div>
              <div>
                {this.renderTags()}
                {this.renderIncludedIngTags()}
                {this.renderExcludedIngTags()}
              </div>
              <button id="clearAll" onClick={this.deleteAllFilteredEle}>
                {this.props.siteTitle && this.props.siteTitle.includes('-es')
                  ? 'Limpiar Selección'
                  : 'Clear All'}
              </button>
            </div>
          ) : null}

          <h4>{includeExcludeTitle}</h4>
          <div className="ingredient-input">{ingredientInput}</div>
          {Object.keys(filterList).map((filterArr, ind) => {
            return (
              <Accordion key={ind}>
                {/* <AccordionItem
                  expanded={filterList[filterArr].some(el =>
                    this.props.state.includes(el.node.slug)
                  )}
                > */}
                <AccordionItem expanded={false}>
                  <AccordionItemTitle id={filterArr.toLowerCase()}>
                    {filterArr}
                    <span className="accordion__arrow" role="presentation" />
                  </AccordionItemTitle>
                  <AccordionItemBody>
                    {filterList[filterArr].map((type, index) => {
                      return (
                        <span key={index} style={{ display: 'block' }}>
                          <label>
                            <input
                              type="checkbox"
                              name={filterArr}
                              value={type.node.slug}
                              onChange={this.selectHandler}
                              ref="checkBox"
                              checked={this.props.state.includes(
                                type.node.slug
                              )}
                            />
                            {ReactHTMLParser(type.node.name)}
                          </label>
                        </span>
                      );
                    })}
                  </AccordionItemBody>
                </AccordionItem>
              </Accordion>
            );
          })}
          <div className="bottomButtonDiv">
            <div id="viewRecipesButton" onClick={filterToggle}>
              {ctaText ? ctaText : 'View Recipes'}
            </div>
          </div>
        </div>
      </Widget>
    );
  }
}

export default FilterWidget;
